export const monoTheme = {
  primary: '#2E81F7',
  secondary: '#0CBD80',
  lightgray: '#ccc8c8',
  themewhite: '#ffffff',
};
